import { Box } from '@chakra-ui/react'


export const TableWrapper = ({ children }: { children: React.ReactNode }) => {
  return <Box sx={{ maxW: '100%', overflow: 'hidden', overflowX: 'auto' }}>{children}</Box>
}